import mixins from '#/app/styles';
import { useIsMobile } from '#/utils';
import { Image, StyleSheet, Text, View } from 'react-native';
import image from '../../../assets/img/infobox.png';

const styles = StyleSheet.create({
  wrapper: {
    padding: 16,
    backgroundColor: mixins().color.darker,
    borderRadius: 8,
    marginBottom: 16,
    flexDirection: 'row',
    gap: 15,
    minHeight: 380,
  },
  mainText: {
    fontSize: 28,
    color: mixins().color.whiteText,
  },
  secondaryText: {
    fontSize: 20,
    color: mixins().color.whiteText,
  },
  text: {
    flexShrink: 1,
    width: '50%',
    gap: 15,
    paddingVertical: 25,
    paddingRight: 25,
    paddingLeft: 25,
    justifyContent: 'center',
  },
  image: {
    width: '50%',
    maxWidth: 700,
    marginLeft: 'auto',
  },
});

export const InfoBox = () => {
  return (
    <View style={[styles.wrapper, useIsMobile() && { flexDirection: 'column', gap: 30 }]}>
      <View style={[styles.text, useIsMobile() && { width: '100%', padding: 0 }]}>
        <Text style={styles.mainText}>
          With cloud streaming, your broadcast is routed through powerful dedicated servers.
        </Text>
        <Text style={styles.secondaryText}>
          This saves your network and processor resources, enables remote control from your mobile
          device, allows transcoding, etc.
        </Text>
        <Text style={styles.secondaryText}>
          To start, simply choose a pricing plan below and follow the instructions.
        </Text>
      </View>
      <Image
        //@ts-expect-error
        source={image}
        style={[styles.image, useIsMobile() && { width: '100%', marginLeft: 0, height: 300 }]}
        resizeMode="contain"
      />
    </View>
  );
};
